import React, { useMemo } from "react";
import { Button, Modal } from "antd";
import ReactDOMServer from "react-dom/server";
import PropTypes from "prop-types";

export const PdfReportReview = ({
	open,
	content,
	renderContent = null,
	extras = {},
	onSetOpen = () => {},
	onConfirmAction = () => {},
	title = "Titulo Vacio",
	confirmText = "Ok",
}) => {
	const renderedHTML = useMemo(() => {
		if (renderContent) {
			return ReactDOMServer.renderToStaticMarkup(renderContent(content, extras));
		}
		return "";
	}, [content, extras, renderContent]);
	
	return (
		<Modal
			open={open}
			centered
			width="80vw"
			style={{ maxWidth: "1000px" }}
			title={title}
			onCancel={() => onSetOpen(false)}
			footer={[
				<Button key="cancel" onClick={() => onSetOpen(false)}>
					Cancelar
				</Button>,
				<Button key="next" type="primary" onClick={onConfirmAction}>
					{confirmText}
				</Button>,
			]}
		>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "flex-start",
					overflow: "auto",
					height: "75vh",
					backgroundColor: "white",
					padding: "20px",
					border: "1px solid #ddd",
					borderRadius: "5px",
					boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
				}}
				dangerouslySetInnerHTML={{ __html: renderedHTML }}
			/>
		</Modal>
	);
};

PdfReportReview.propTypes = {
	open: PropTypes.bool.isRequired,
	content: PropTypes.object.isRequired,
	renderContent: PropTypes.func.isRequired,
	extras: PropTypes.object,
	onSetOpen: PropTypes.func,
	onConfirmAction: PropTypes.func,
	title: PropTypes.string,
	confirmText: PropTypes.string,
};
